module.exports = __webpack_public_path__ + "img/hat05_uv_belt_right.4ea98491.svg";